import { render } from "./StatementCard.vue?vue&type=template&id=7c88405e&scoped=true"
import script from "./StatementCard.vue?vue&type=script&lang=js"
export * from "./StatementCard.vue?vue&type=script&lang=js"

import "./StatementCard.vue?vue&type=style&index=0&id=7c88405e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c88405e"]])

export default __exports__